import { Component, input } from '@angular/core';
import { NodeProduct } from '@app/models/entity.model';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { ProductLayoutComponent } from '@app/components/product/product-layout/product-layout.component';

@Component({
  selector: 'mobi-node-product',
  templateUrl: './node-product.component.html',
  styleUrls: ['./node-product.component.scss'],
  standalone: true,
  imports: [EntitySharedModule, ProductLayoutComponent],
})
export class NodeProductComponent {
  readonly entity = input.required<NodeProduct>();
}
